document.addEventListener('DOMContentLoaded', function () {
    const loginForm = document.querySelector('form[data-login]');

    if (loginForm) {
        loginForm.addEventListener("submit", (e) => {
            e.preventDefault();
            (async () => {
                const response = await fetch(site.constants.api.login, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: loginForm.querySelector("#login-username").value,
                        password: loginForm.querySelector("#login-password").value,
                    })
                });


                if (response.status !== 200) {

                }
                else {
                    location.reload();
                }
            })();

            
        });
    }
});
